package com.markettwits.theme.components

import androidx.compose.ui.unit.dp

/** Shared rhythm; image canvases deliberately keep their edge-to-edge layout. */
object WaifuSpacing {
    val small = 8.dp
    val item = 12.dp
    val content = 16.dp
    val screen = 20.dp
    val section = 24.dp
}

object WaifuSize {
    val touchTarget = 48.dp
    val icon = 18.dp
    val overlayControl = 40.dp
    val overlayIcon = 22.dp
    val sheetWidth = 640.dp
}
